<script lang="ts">
    import { getDBEntry } from "../../api"
    import { spaLink } from "../actions"
    import { navigationCache } from "../store"
    let navigationEntry: NavigationEntry = { elements: [] }

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) {
                    // only first hit to cache
                    $navigationCache[el.page] = el
                }
            }
        })
    }

    getDBEntry("navigation", {
        tree: 1,
    }).then((nav) => {
        // @ts-ignore
        navigationEntry = nav || { elements: [] }
        elementsToCache(nav?.elements || [])
    })
</script>

<footer class="paddingExtended">
    <div class="wrapper-footer">
        <div class="left">
            <address class="address">
                <h5>Adresse</h5>
                <div>rechTEC Rechtsanwälte</div>
                <div>Flughafenstraße 12</div>
                <div>99092 Erfurt</div>
            </address>
            <div class="contact">
                <h5>Erreichbarkeit</h5>
                <div>Telefon: 0361 - 789 298 65</div>
                <div>Telefax: 0361-789 298 66</div>
                <div>Email: <a href="mailto:kanzlei@rechtec.de"> kanzlei@rechtec.de </a></div>
            </div>
        </div>
        <div class="right">
            <div>
                <h5>Service</h5>
                <ul>
                    {#each navigationEntry?.elements || [] as element}
                        {#if element}
                            <li>
                                <a href="{element.page}" use:spaLink>{element.name}</a>
                            </li>
                        {/if}
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</footer>

<style lang="less">
    @import "../../css/variables.less";
    footer {
        background-color: var(--white-100);
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 120px 0px;
        margin-top: -48px;
        .wrapper-footer {
            margin: 0px var(--horizontal-default-margin);
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: var(--default-gap);
            max-width: var(--normal-max-width);
            width: 100%;
            @media @mobile {
                flex-direction: column;
                align-items: flex-start;
            }
            .left,
            .right {
                a {
                    color: var(--grey-100);
                    text-decoration: none;
                }

                display: flex;
                gap: var(--default-gap);
                align-items: flex-start;
                @media @mobile {
                    flex-direction: column;
                    align-items: flex-start;
                }
                & > div,
                address {
                    font-style: normal;
                    color: var(--grey-100);
                    h5 {
                        font-family: Gudea;
                        font-size: 0.9rem;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 140%;
                        color: var(--blue-100);
                        margin: 0px;
                        margin-bottom: 12px;
                    }
                }
            }
            .right {
                h5 {
                    text-align: end;
                    @media @mobile {
                        text-align: start;
                    }
                }
                ul {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    margin-top: 24px;

                    li {
                        display: flex;
                        justify-content: flex-end;
                        @media @mobile {
                            justify-content: flex-start;
                        }
                    }
                }
            }
        }
    }
</style>
